import StringUtil from '@leverege/string-util';
import { Attributes } from '@leverege/ui-attributes';
export default {
  id: 'molten.attributeCreator.timeSinceTimestamp',
  type: 'timeSinceTimestamp',
  create(model, attr, opts) {
    if (attr == null) {
      return;
    }
    const attribute = attr.source?.attribute;
    if (!attribute) {
      return;
    }
    if (attr.valueType !== 'timestamp') {
      return;
    }
    const {
      blueprint,
      molten
    } = opts;
    const {
      path
    } = attribute;
    const {
      options,
      name
    } = model;
    if (!options) {
      return;
    }
    const fieldPath = `data/${path}`;
    // const dPath = path.replaceAll( '/', '.' )
    const source = {
      type: 'imagine.Blueprint',
      field: fieldPath,
      editable: false,
      attribute,
      renamed: false
    };
    const attrOpts = {
      filterable: false,
      sortable: false,
      i18nGetter: (...args) => attribute.getString(...args)
    };
    const objectType = blueprint.type;
    const comparisonTimestamp = options.comparisonTimestamp || 'now';
    const attrName = `${attr.name}.timeSinceTimestamp.${comparisonTimestamp}`;
    // const attrName = `${dPath}.timeSinceTimestamp.${comparisonTimestamp}`
    const compAttr = comparisonTimestamp === 'now' ? null : Attributes.getAttribute(comparisonTimestamp, objectType);
    const defaultName = comparisonTimestamp === 'now' || !compAttr ? `Time Since ${StringUtil.camelCaseToTitleCase(attr.displayName)}` : `Time Between ${StringUtil.camelCaseToTitleCase(attr.displayName)} and ${StringUtil.camelCaseToTitleCase(compAttr.displayName)}`;
    const a = {
      id: `${blueprint.type}.${path}.timeSinceTimestamp.${comparisonTimestamp}`,
      name: attrName,
      displayName: name || defaultName,
      valueType: 'time',
      baseUnit: 'ms',
      objectType,
      layout: {
        group: ['Time Since Date', attr.displayName],
        sort: 'zzz'
      },
      get(obj) {
        const comp = comparisonTimestamp === 'now' ? new Date() : compAttr?.get(obj);
        const value = Attributes.get(attr.name, objectType, obj);
        if (value && comp) {
          return {
            type: 'time',
            unit: 'ms',
            value: comp.valueOf() - value.valueOf()
          };
        }
        return null;
      },
      getOption(key) {
        return attrOpts[key];
      },
      blueprint: source,
      source
    };
    molten.addPlugin('Attribute', a);
  }
};